/**
 * Created by gy on 2018/5/22.
 */
import Vue from 'vue'
import axios from 'axios'
import { serverUrl, API_FAILED } from './config'
import { baseUrl, baseUrl2 } from '../common/env'

import { getCookie } from '../common/js/util/util'

import { Toast, Dialog } from 'vant'
import router from '../router'

export function post(str, data = {}, param = {}, isShowLoading = false) {
  const url = baseUrl + str
  //serverUrl.req.param = p;

  var authorization = getCookie('token_bshop') //获取Cookie

  var instance = axios.create({
    baseURL: url,
    method: 'post',
    headers: { authorization: authorization },
  })

  // request拦截器
  instance.interceptors.request.use(
    (config) => {
      if (isShowLoading) {
        // 显示loading
        Toast.loading({
          duration: 0, // 持续展示 toast
          /*message: '加载中...',*/
          forbidClick: true,
        })
      }

      return config
    },
    (error) => {
      if (isShowLoading) {
        // 隐藏loading
        Toast.clear()
      }

      console.log(error)
      Promise.reject(error)
    }
  )

  return instance({
    method: 'post',
    url: url,
    params: param,
    data: data,
  })
    .then((res) => {
      console.log('post result : ', res.data)

      if (isShowLoading) {
        // 隐藏loading
        Toast.clear()
      }

      let code = res.data.code
      let msg = res.data.message
      if (code == '400') {
        if (!msg) {
          msg = 'Bad Request'
        }
      } else if (code == '401') {
        if (!msg) {
          msg = 'Unauthorized'
        }
      } else if (code == '403') {
        if (!msg) {
          msg = 'Forbidden'
        }
      } else if (code == '404') {
        if (!msg) {
          msg = 'Not Found'
        }
      } else if (code == '405') {
        if (!msg) {
          msg = 'Method Not Allowed'
        }
      } else if (code == '412') {
        // 后端服务业务校验失败 - 依据业务需定制化处理
        if (!msg) {
          msg = '业务校验失败'
        }
      } else if (code == '417') {
        // 后端服务业务校验失败 - 公共处理
        if (!msg) {
          msg = '业务校验失败'
        }
      } else if (code == '500') {
        if (!msg) {
          msg = 'Internal Server Error'
        }
      } else if (code != '200') {
        if (!msg) {
          msg = 'Unknown Error'
        }
      }

      if (code == '412') {
        // 412 code用于特定业务的处理 - 直接return服务端返回的数据, 由调用者自行处理
        return res.data
      } else if (code != '200') {
        if (code == 401) {
          return Promise.reject(new Error(code + ':' + msg))
        }
        Dialog.alert({
          theme: 'round-button',
          message: msg,
          confirmButtonColor: '#00754A',
        })
      } else {
        return res.data
      }
    })
    .catch((error) => {
      if (isShowLoading) {
        // 隐藏loading
        Toast.clear()
      }

      let { message } = error
      if (!message) {
        message = 'Unknown Error'
      }

      let message2 = '服务异常, 请稍后重试'

      Dialog.alert({
        theme: 'round-button',
        message: message2,
        confirmButtonColor: '#00754A',
      }).then(() => {
        if (message.indexOf('401') > -1) {
          Vue.prototype.$delCookie('token_bshop')
          // Vue.prototype.$cookie.delete('token_bshop')
          let url =
            baseUrl +
            'oauth2/authorize/JH001?redirectUrl=' +
            encodeURIComponent(baseUrl2 + router.currentRoute.fullPath)
          console.log(url)
          window.location.href = url
        }
      })
      return Promise.reject(new Error(message))
    })
}



// WEBPACK FOOTER //
// ./src/api/post.js